import lfRequest from '@/service/index'

export function queryStatisticalCustomDeleted(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/main/customDeleted/queryStatisticsNum',
    params: queryInfo
  })
}

export function queryStatisticalNewResource(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/main/newResourceStatistics/queryStatisticsNum',
    params: queryInfo
  })
}

export function queryDrainageStatistics(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/main/drainageStatistics/totalStatistics',
    params: queryInfo
  })
}

export function queryDrainageSummaryStatistics(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/main/customerChannelStatistics/statisticsByCondition',
    params: {
      forceRefresh: false,
      ...queryInfo
    }
  })
}

export function queryStatistical(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/main/liveStatisticalDept/queryStatistical',
    params: queryInfo
  })
}

export function statisticDay(channelId: number) {
  return lfRequest.get<any>({
    url: '/live/statistic/day',
    params: { channelId }
  })
}

export function statisticOnlineNumber(channelId: number) {
  return lfRequest.get<any>({
    url: '/live/statistic/onlineNumber',
    params: {channelId}
  })
}
